import { shared } from './NavIcons';

/** Small icons for the dashboard's cards, matching the side nav's outline style. */

export function WarningIcon() {
  return (
    <svg {...shared}>
      <path d="M12 4 3 19h18L12 4Z" />
      <path d="M12 10.5v3.5" />
      <circle cx="12" cy="16.7" r="0.15" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function ClockIcon() {
  return (
    <svg {...shared}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3 2" />
    </svg>
  );
}

export function InvoiceIcon() {
  return (
    <svg {...shared}>
      <path d="M6.5 3.5h11a1 1 0 0 1 1 1V20l-2.5-1.5L13.5 20l-2-1.5L9.5 20 7 18.5 5.5 20V4.5a1 1 0 0 1 1-1Z" />
      <path d="M8.5 8h7M8.5 11.5h7M8.5 15h4" />
    </svg>
  );
}
